import * as React from 'react';
import { Link, Outlet } from 'react-router-dom';

export default function InventoryDashboard(): React.ReactElement {
  return (
    <div style={{ padding: '10px' }}>
      <h2>Inventory Dashboard</h2>
      <p>Hier kannst du Inventory Items, Listen und Zählungen verwalten.</p>

      <nav style={{ marginBottom: '10px' }}>
        <Link to="items" style={{ marginRight: '10px' }}>
          Items
        </Link>
        <Link to="lists" style={{ marginRight: '10px' }}>
          Lists
        </Link>
        <Link to="counts" style={{ marginRight: '10px' }}>
          Counts
        </Link>
      </nav>

      {/* Hier werden verschachtelte Routen (Nested Routes) gerendert. */}
      <Outlet />
    </div>
  );
} 